import { render, staticRenderFns } from "./AllTodoView.vue?vue&type=template&id=1c87d88c"
import script from "./AllTodoView.vue?vue&type=script&lang=js"
export * from "./AllTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports